"use client";

type GlobalErrorPageProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalErrorPage({ error, reset }: GlobalErrorPageProps) {
  return (
    <html lang="en">
      <body>
        <div className="mx-auto flex min-h-screen max-w-2xl flex-col items-start justify-center gap-4 px-6 py-12">
          <div>
            <h2 className="text-2xl font-bold text-slate-900">Application error</h2>
            <p className="mt-2 text-sm text-slate-600">
              The app hit an unexpected error while rendering.
            </p>
          </div>
          <div className="rounded border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-800">
            {error.message || "Unknown error"}
          </div>
          <button
            type="button"
            onClick={reset}
            className="rounded bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-slate-800"
          >
            Reload
          </button>
        </div>
      </body>
    </html>
  );
}
